import { ErrorResponse } from '@genial/services';

import { FilterModalTypes } from '../../components/FilterModal';
import { Tags } from '../../pages/BatchTicket/utils/types';

export const customerTags = { list: [], added: {}, removed: {} } as unknown as Tags;
export const screenName = 'batch-ticket';
export const customerParams = { limit: 40, page: 1, screenName };
export const customerSearchTermParams = { limit: 100, page: 1, screenName };
export const messageError = '―';
export const customerAvailableFilter = [] as FilterModalTypes.FilterType[];

export const batchTicketRedeemAvailableFilter = [
  {
    type: 'section',
    title: 'Status',
    fieldName: 'basketOfferStatus',
    options: [
      { label: 'Á liquidar', value: 'Executed' },
      { label: 'Liquidada', value: 'Settled' },
      { label: 'Cancelada', value: 'Canceled' },
      { label: 'Rejeitada', value: 'Rejected' },
      { label: 'Expirada', value: 'Expired' },
      { label: 'Erro na ordem', value: 'Error' },
    ],
  },
  {
    type: 'range',
    title: 'Valor da boleta',
    fieldName: 'applicationAmount',
    max: 10000000,
    min: 0,
    labelType: 'money',
  },
] as FilterModalTypes.FilterType[];

export const getCommonRequireOrderOriginError = (): ErrorResponse => ({
  errorId: Math.floor(Math.random() * 1000).toString(),
  errorTimestamp: new Date(),
  errorCode: 'order_origin_required',
  errorTitle: 'Comprovação de origem da ordem',
  errorDisplay: 'toast',
  errorMessage: 'A comprovação de origem é obrigatória.',
  errorSuggest: 'Por favor, antes de enviar, informe a origem da boleta.',
  errorLanguage: 'pt-BR',
});
